// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__38Vg7","signatureButtonsRight":"ModalSign_signatureButtonsRight___p33L"};